// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1JoYx","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__gSu2W"};